import React from 'react';
import { useSelector } from 'react-redux';
import { NamePrefixModifier, withInjectedProps } from '../../../../Core/InjectedPropsContext';
import { PageSection } from '../../../../Layout';
import { IWorksheetComponent, WorksheetAssociatedTestSection } from '../../../Core';
import { PreparationMethod } from '../../types';
import HydrometerPortionPretreatmentPreparationSection from './HydrometerPortionPretreatmentPreparationSection';
import HydrometerPortionWetPreparationSection from './HydrometerPortionWetPreparationSection';

let PortionPreparationPageSection: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  const preparationMethod: PreparationMethod = useSelector(
    createWorksheetSelector!('HydrometerPortion.Preparation.PreparationMethod')
  );

  const pretreatedMaterial = preparationMethod === PreparationMethod.PreTreated;
  const wetMaterial = preparationMethod === PreparationMethod.Moist;

  return (
    <>
      <PageSection heading="Hydrometer Portion Preparation">
        <NamePrefixModifier appendNamePrefix="HydrometerPortion">
          {wetMaterial && <HydrometerPortionWetPreparationSection />}
          {pretreatedMaterial && <HydrometerPortionPretreatmentPreparationSection />}

          <WorksheetAssociatedTestSection
            heading="Washing"
            testType="Wash"
            associatedTestModel={{
              measured: true,
            }}
            name="Washing.AssociatedWashTest"
            indented={false}
          />
        </NamePrefixModifier>
      </PageSection>
    </>
  );
};

PortionPreparationPageSection = withInjectedProps(PortionPreparationPageSection);

export { PortionPreparationPageSection };
export default PortionPreparationPageSection;
